import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FormatOptions } from '../../../../../common/table/CellTypeConstants';
import { getCurrencyDropdownLabel, getCurrencyList } from '../../../../utils/currencyUtils';
import Icon from '../../../../components/icons/Icon';
import { getCurrencyDisplayOptions } from '../../../../../common/table/utils/tableCellFormattingUtils';
import SelectInput from '../../../../components/select/SelectInput';
import { userCurrencyDisplayLocaleSelector } from '../../../../user/currentUserSelector';

import { useTranslator } from '../../../../components/i18n/useTranslator';

const CurrencyFormatOptions = (props) => {
    const { sharedFormattingValues, updateCellTypeFormat, locale } = props;
    const { currency, currencyDisplay } = sharedFormattingValues;
    const translate = useTranslator('popup', 'table.format');
    const currencyDisplayLocale = useSelector(userCurrencyDisplayLocaleSelector);

    return (
        <div className="CurrencyFormatOptions celltype-format-section">
            <div className="celltype-format-title">{translate('currency')}</div>
            <div className="celltype-format-inputs">
                <div className="dropdown-container celltype-format-input">
                    <SelectInput
                        value={currency || ''}
                        onChange={(e) => updateCellTypeFormat({ [FormatOptions.CURRENCY]: e.target.value })}
                        className="dropdown"
                    >
                        <option value="" disabled>
                            {translate('selectCurrency')}
                        </option>
                        {getCurrencyList(currencyDisplayLocale).map(({ id, label, currencyCode }) => (
                            <option key={id} value={id}>
                                {getCurrencyDropdownLabel({ label, currencyCode })}
                            </option>
                        ))}
                    </SelectInput>
                    <div className="arrow-icon-container">
                        <Icon name="dropdown-arrow" />
                    </div>
                </div>
                {currency && (
                    <div className="dropdown-container celltype-format-input">
                        <SelectInput
                            value={currencyDisplay}
                            onChange={(e) => updateCellTypeFormat({ [FormatOptions.CURRENCY_DISPLAY]: e.target.value })}
                            className="dropdown"
                        >
                            {getCurrencyDisplayOptions(currency, locale).map((displayOption) => (
                                <option key={displayOption.id} value={displayOption.id}>
                                    {displayOption.label}
                                </option>
                            ))}
                        </SelectInput>
                        <div className="arrow-icon-container">
                            <Icon name="dropdown-arrow" />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

CurrencyFormatOptions.propTypes = {
    sharedFormattingValues: PropTypes.object,
    updateCellTypeFormat: PropTypes.func,
    locale: PropTypes.string,
};

export default CurrencyFormatOptions;
